import { render, staticRenderFns } from "./invadjustgroup.vue?vue&type=template&id=2ac2f9da"
import script from "./invadjustgroup.vue?vue&type=script&lang=js"
export * from "./invadjustgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports